import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'

dayjs.extend(customParseFormat)

export function getChartUploadDateRangeWithDay(chartDate: string | number | Date | dayjs.Dayjs) {
  const date = dayjs(chartDate, 'DD/MM/YY')
  const endDate = dayjs(date).valueOf()
  const startDate = dayjs(date).subtract(1, 'day').valueOf()

  return { startDate, endDate }
}

export default function getChartUploadDateRange(
  chartDate: string | number | Date | dayjs.Dayjs,
  format: string = 'MMM/YYYY'
) {
  const date = dayjs(chartDate, format)
  const startDate = dayjs(date).valueOf()
  const endDate = dayjs(date).endOf('month').valueOf()

  return { startDate, endDate }
}
